import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ClientProfileModal = ({ client, onClose }) => {
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'Overview', icon: 'User' },
    { id: 'subscription', label: 'Subscription', icon: 'CreditCard' },
    { id: 'payments', label: 'Payments', icon: 'DollarSign' },
    { id: 'activity', label: 'Activity', icon: 'Activity' },
    { id: 'usage', label: 'Usage', icon: 'BarChart3' }
  ];

  const mockPayments = [
    { id: 1, date: '2026-02-01', amount: client?.mrr, status: 'success', invoice: 'INV-2026-02-001' },
    { id: 2, date: '2026-01-01', amount: client?.mrr, status: 'success', invoice: 'INV-2026-01-001' },
    { id: 3, date: '2025-12-01', amount: client?.mrr, status: 'success', invoice: 'INV-2025-12-001' }
  ];

  const mockActivity = [
    { id: 1, action: 'Generated Predictive Analysis Report', timestamp: '2026-02-07 14:30', module: 'Predictive Analysis' },
    { id: 2, action: 'Updated Business Model Canvas', timestamp: '2026-02-06 10:15', module: 'BMC' },
    { id: 3, action: 'Viewed Dashboard', timestamp: '2026-02-05 09:00', module: 'Dashboard' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'overview':
        return (
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-xs text-muted-foreground font-caption">Company Name</label>
                <p className="text-sm font-medium text-foreground font-body mt-1">{client?.companyName}</p>
              </div>
              <div>
                <label className="text-xs text-muted-foreground font-caption">Contact Person</label>
                <p className="text-sm font-medium text-foreground font-body mt-1">{client?.contactName}</p>
              </div>
              <div>
                <label className="text-xs text-muted-foreground font-caption">Email</label>
                <p className="text-sm font-medium text-foreground font-body mt-1">{client?.email}</p>
              </div>
              <div>
                <label className="text-xs text-muted-foreground font-caption">Phone</label>
                <p className="text-sm font-medium text-foreground font-body mt-1">{client?.phone}</p>
              </div>
              <div>
                <label className="text-xs text-muted-foreground font-caption">Registration Date</label>
                <p className="text-sm font-medium text-foreground font-body mt-1">{client?.registrationDate}</p>
              </div>
              <div>
                <label className="text-xs text-muted-foreground font-caption">Last Activity</label>
                <p className="text-sm font-medium text-foreground font-body mt-1">{client?.lastActivity}</p>
              </div>
            </div>
          </div>
        );
      case 'subscription':
        return (
          <div className="space-y-4">
            <div className="bg-muted/30 rounded-lg p-4">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <p className="text-xs text-muted-foreground font-caption">Current Plan</p>
                  <p className="text-xl font-bold text-foreground font-heading mt-1">{client?.planType}</p>
                </div>
                <span className={`px-3 py-1 rounded-full text-xs font-medium font-caption ${
                  client?.subscriptionStatus === 'active' ? 'bg-success/10 text-success' :
                  client?.subscriptionStatus === 'trial'? 'bg-info/10 text-info' : 'bg-warning/10 text-warning'
                }`}>
                  {client?.subscriptionStatus}
                </span>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-xs text-muted-foreground font-caption">Monthly Recurring Revenue</p>
                  <p className="text-lg font-semibold text-foreground font-body mt-1">₹{client?.mrr?.toLocaleString()}</p>
                </div>
                <div>
                  <p className="text-xs text-muted-foreground font-caption">Billing Cycle</p>
                  <p className="text-lg font-semibold text-foreground font-body mt-1">Monthly</p>
                </div>
              </div>
            </div>
            <div className="flex gap-2">
              <button className="flex-1 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-smooth text-sm font-medium font-body">
                Change Plan
              </button>
              <button className="flex-1 px-4 py-2 bg-card border border-border text-foreground rounded-md hover:bg-muted transition-smooth text-sm font-medium font-body">
                Adjust Billing
              </button>
            </div>
          </div>
        );
      case 'payments':
        return (
          <div className="space-y-3">
            {mockPayments?.map((payment) => (
              <div key={payment?.id} className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
                <div>
                  <p className="text-sm font-medium text-foreground font-body">{payment?.invoice}</p>
                  <p className="text-xs text-muted-foreground font-caption mt-0.5">{payment?.date}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-semibold text-foreground font-body">₹{payment?.amount?.toLocaleString()}</p>
                  <span className="inline-flex items-center gap-1 text-xs text-success font-caption mt-0.5">
                    <Icon name="CheckCircle" size={12} />
                    Success
                  </span>
                </div>
              </div>
            ))}
          </div>
        );
      case 'activity':
        return (
          <div className="space-y-3">
            {mockActivity?.map((activity) => (
              <div key={activity?.id} className="flex items-start gap-3 p-3 bg-muted/30 rounded-lg">
                <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="Activity" size={16} color="var(--color-primary)" />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium text-foreground font-body">{activity?.action}</p>
                  <p className="text-xs text-muted-foreground font-caption mt-0.5">{activity?.timestamp}</p>
                  <span className="inline-block mt-1 px-2 py-0.5 bg-primary/10 text-primary text-xs rounded font-caption">
                    {activity?.module}
                  </span>
                </div>
              </div>
            ))}
          </div>
        );
      case 'usage':
        return (
          <div className="space-y-4">
            <div className="bg-muted/30 rounded-lg p-4">
              <p className="text-xs text-muted-foreground font-caption mb-3">Report Downloads</p>
              <div className="flex items-end gap-2">
                <p className="text-3xl font-bold text-foreground font-heading">12</p>
                <p className="text-sm text-muted-foreground font-caption mb-1">/ 50 this month</p>
              </div>
              <div className="w-full bg-muted rounded-full h-2 mt-3">
                <div className="bg-primary h-2 rounded-full" style={{ width: '24%' }} />
              </div>
            </div>
            <div className="bg-muted/30 rounded-lg p-4">
              <p className="text-xs text-muted-foreground font-caption mb-3">AI Usage</p>
              <div className="flex items-end gap-2">
                <p className="text-3xl font-bold text-foreground font-heading">245</p>
                <p className="text-sm text-muted-foreground font-caption mb-1">/ 1000 queries</p>
              </div>
              <div className="w-full bg-muted rounded-full h-2 mt-3">
                <div className="bg-success h-2 rounded-full" style={{ width: '24.5%' }} />
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg elevation-lg w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h2 className="text-xl font-bold text-foreground font-heading">{client?.companyName}</h2>
            <p className="text-sm text-muted-foreground font-caption mt-1">{client?.email}</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-md hover:bg-muted transition-smooth"
          >
            <Icon name="X" size={20} className="text-muted-foreground" />
          </button>
        </div>

        {/* Tabs */}
        <div className="flex gap-1 px-6 pt-4 border-b border-border overflow-x-auto">
          {tabs?.map((tab) => (
            <button
              key={tab?.id}
              onClick={() => setActiveTab(tab?.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-t-md text-sm font-medium font-body transition-smooth whitespace-nowrap ${
                activeTab === tab?.id
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-muted/50'
              }`}
            >
              <Icon name={tab?.icon} size={14} />
              {tab?.label}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          {renderTabContent()}
        </div>

        {/* Actions */}
        <div className="flex items-center justify-between p-6 border-t border-border bg-muted/30">
          <div className="flex gap-2">
            <button className="flex items-center gap-2 px-4 py-2 bg-success text-white rounded-md hover:bg-success/90 transition-smooth text-sm font-medium font-body">
              <Icon name="CheckCircle" size={16} />
              Activate Account
            </button>
            <button className="flex items-center gap-2 px-4 py-2 bg-warning text-white rounded-md hover:bg-warning/90 transition-smooth text-sm font-medium font-body">
              <Icon name="AlertCircle" size={16} />
              Suspend Account
            </button>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 bg-card border border-border text-foreground rounded-md hover:bg-muted transition-smooth text-sm font-medium font-body">
            <Icon name="Mail" size={16} />
            Send Message
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientProfileModal;